import React, { useState } from "react";
import PasswordInput from "./PasswordInput";

export default function LoginStep({
  email,
  onEmailChange,
  onSubmit,
  loading,
  error,
  initialAlreadyUpdated,
}) {
  const [password, setPassword] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const submittedPassword = password;
    setPassword("");
    await onSubmit({
      email,
      password: submittedPassword,
      alreadyUpdated: Boolean(initialAlreadyUpdated),
    });
  };

  return (
    <div className="onboarding-card-inner">
      <div className="onboarding-step-head">
        <div>
          <h2>Inicia sesión</h2>
          <p>Usa el correo registrado y tu contraseña actual.</p>
        </div>
        <span className="onboarding-step-count">Paso 1 de 3</span>
      </div>

      {error && <p className="onboarding-error" role="alert">{error}</p>}

      <form className="onboarding-form" onSubmit={handleSubmit}>
        <div className="onboarding-field">
          <label htmlFor="onboarding-email">Correo electrónico</label>
          <input
            id="onboarding-email"
            className="onboarding-input"
            type="email"
            name="email"
            autoComplete="username"
            inputMode="email"
            required
            value={email}
            onChange={(event) => onEmailChange(event.target.value)}
            disabled={loading}
          />
        </div>

        <div className="onboarding-field">
          <label htmlFor="onboarding-current-password">Contraseña actual</label>
          <PasswordInput
            id="onboarding-current-password"
            name="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            disabled={loading}
            showLabel="Mostrar contraseña actual"
            hideLabel="Ocultar contraseña actual"
          />
        </div>

        <div className="onboarding-button-row">
          <span />
          <button
            className="onboarding-button onboarding-button--primary"
            type="submit"
            disabled={loading || !email.trim() || !password}
          >
            {loading ? "Verificando…" : "Continuar"}
          </button>
        </div>
      </form>
    </div>
  );
}
